<template>
    <div v-if="isOpen"
        class="cierra-chat-window md:ctw-rounded-xl ctw-shadow-lg md:ctw-w-96 ctw-w-screen ctw-h-screen md:ctw-h-[570px] ctw-flex ctw-flex-col md:ctw-border md:ctw-border-solid ctw-outline-white6 ctw-pb-3" :style="{ backgroundColor }">
        <slot />
    </div>
</template>

<script setup>
import { useWidgetStore } from '@/store/widget';
import { computed } from 'vue';


const widgetStore = useWidgetStore();

const isOpen = computed(() => widgetStore.isChatOpen);

const backgroundColor = widgetStore.backgroundColor;

</script>